/**
 * @learnzapp/core/theme — the single source of truth for colors in BOTH apps.
 *
 * - ./baseColors  canonical light/dark color scales (BASE_COLORS_LIGHT/_DARK)
 * - ./colorUtils  pure hex/rgba helpers (lighten, darken, addOpacity, …)
 * - ./palette     brand palette seed + resolver (DEFAULT_PALETTE, …)
 * - ./brands      brand palette registry (BRAND_PALETTES, getPalette)
 * - ./themes      assembled theme objects + getColorTheme(mode, platform, brand)
 *
 * Pure data and pure functions only — no platform SDKs, no UI. Each app's
 * ThemeProvider stays in the app (localStorage vs Firebase/Appearance is
 * platform plumbing); only the values it serves come from here.
 */
export * from './colorUtils';
export * from './baseColors';
export * from './palette';
export * from './brands';
export * from './themes';
